<script setup lang="ts">
import { ChevronRightIcon } from 'lucide-vue-next'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '~/components/ui/tabs'
import type { IFaqItem } from '~/components/entity/faq/items/types'

import './style.css'

const props = defineProps<{
  items: IFaqItem[]
}>()

const { items } = toRefs(props)

const SCROLL_OFFSET = 40

const scrollToContent = (itemId: number) => {
  nextTick(() => {
    const contentElement = document.querySelector(`[data-value="faq-tab-${itemId}"]`)
    const headerElement = document.getElementById('layout-header')

    if (contentElement) {
      const headerHeight = headerElement?.offsetHeight || 0
      const elementTop = contentElement.getBoundingClientRect().top + window.scrollY
      const scrollPosition = elementTop - headerHeight - SCROLL_OFFSET

      window.scrollTo({
        top: scrollPosition,
        behavior: 'smooth'
      })
    }
  })
}
</script>

<template>
  <Tabs
    v-if="items.length > 0"
    :default-value="`faq-tab-${items[0].id}`"
    orientation="vertical"
    class="faq-sidebar-container"
  >
    <TabsList class="faq-sidebar-tabs-list">
      <TabsTrigger
        v-for="item in items"
        :key="item.id"
        :value="`faq-tab-${item.id}`"
        class="faq-sidebar-tab-trigger"
        @click="scrollToContent(item.id)"
      >
        {{ item.title }}
        <ChevronRightIcon class="faq-sidebar-tab-icon" />
      </TabsTrigger>
    </TabsList>

    <TabsContent
      v-for="item in items"
      :key="item.id"
      :value="`faq-tab-${item.id}`"
      class="faq-sidebar-tab-content"
    >
      <article :data-value="`faq-tab-${item.id}`" v-html="item.description" />
    </TabsContent>
  </Tabs>

  <div v-else class="faq-sidebar-empty-state">{{ $t('entity.faq.no_available_questions') }}</div>
</template>
